import React, { useState, useEffect } from 'react';
import './InstallPrompt.css'; 

const InstallPrompt = () => {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [isIOS, setIsIOS] = useState(false);
  const [isStandalone, setIsStandalone] = useState(false);
  const [showPrompt, setShowPrompt] = useState(false);

  useEffect(() => {
    // 1. Verifica se JÁ ESTÁ rodando como aplicativo na tela inicial
    // O navigator.standalone é uma verificação exclusiva para o iPhone/iPad
    if (window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true) {
      setIsStandalone(true);
      return; // Se já instalou, aborta aqui e não mostra nada
    }

    // 2. Detecta se é um iPhone/iPad
    const userAgent = window.navigator.userAgent.toLowerCase();
    const isIosDevice = /iphone|ipad|ipod/.test(userAgent);
    setIsIOS(isIosDevice);

    if (isIosDevice) {
      // LÓGICA DO IPHONE: Conta quantas vezes a mensagem já apareceu
      const promptCount = parseInt(localStorage.getItem('iosPromptCount') || '0', 10);
      
      // Se apareceu menos de 2 vezes, mostra a mensagem e soma +1 na conta
      if (promptCount < 2) {
        setShowPrompt(true);
        localStorage.setItem('iosPromptCount', (promptCount + 1).toString());
      }
    }

    // 3. Lógica padrão do Android
    const handleBeforeInstallPrompt = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setShowPrompt(true);
    };

    window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);

    return () => {
      window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
    };
  }, []);

  // Função para fechar no Android
  const handleInstallClick = async () => {
    if (deferredPrompt) {
      deferredPrompt.prompt();
      const { outcome } = await deferredPrompt.userChoice;
      if (outcome === 'accepted') {
        setShowPrompt(false);
      }
      setDeferredPrompt(null);
    }
  };

  // Função para fechar manualmente no iPhone
  const handleCloseIOS = () => {
    setShowPrompt(false);
    // Opcional: Se quiser que ao clicar em "Fechar" ele NUNCA MAIS apareça, 
    // descomente a linha abaixo:
    // localStorage.setItem('iosPromptCount', '99'); 
  };

  // Se já estiver como app ou a variável showPrompt for falsa, esconde tudo
  if (isStandalone || !showPrompt) return null;

  return (
    <div className="install-banner">
      <div className="install-content">
        <h4>Instalar Sistema Integrado Acadêmico</h4>
        {isIOS ? (
          <>
            <p>
              Para adiconar um icone dedicado no seu iPhone: toque no ícone de <b>Compartilhar</b> (o quadrado com a setinha para cima) e selecione <b>Adicionar à Tela de Início</b>.
            </p>
            <div className="install-actions">
              <button onClick={handleCloseIOS} className="btn-cancelar">Fechar</button>
            </div>
          </>
        ) : (
          <>
            <p>Adicione o Sistema integrado acadêmico à sua tela inicial para acesso mais rápido e em tela cheia.</p>
            <div className="install-actions">
              <button onClick={() => setShowPrompt(false)} className="btn-cancelar">Agora não</button>
              <button onClick={handleInstallClick} className="btn-instalar">Instalar Aplicativo</button>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default InstallPrompt;